import axios, { AxiosRequestConfig } from 'axios';

axios.defaults.timeout = 30000;
axios.defaults.withCredentials = true;
axios.defaults.headers.common = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export const setBaseUrl = (apiHost: string) => {
  axios.defaults.baseURL = `${apiHost}/v1/self_service`;
};

export const updateDefaultHeaders = (headers: { [key: string]: string }) => {
  axios.defaults.headers.common = {
    ...axios.defaults.headers.common,
    ...headers,
  };
};

const performRequest = async <TResponse>(config: AxiosRequestConfig) => {
  const response = await axios.request<TResponse>(config);
  return response.data;
};

const performGet = <TResponse>(
  url: string,
  params: object = {},
  config: AxiosRequestConfig = {}
) =>
  performRequest<TResponse>({
    ...config,
    method: 'get',
    params,
    url,
  });

const performPost = <TData, TResponse>(
  url: string,
  data: TData,
  config: AxiosRequestConfig = {}
) =>
  performRequest<TResponse>({
    ...config,
    data,
    method: 'post',
    url,
  });

const performPut = <TData, TResponse>(
  url: string,
  data: TData,
  config: AxiosRequestConfig = {}
) =>
  performRequest<TResponse>({
    ...config,
    data,
    method: 'put',
    url,
  });

const performDelete = <TData, TResponse>(
  url: string,
  data: TData,
  config: AxiosRequestConfig = {}
) =>
  performRequest<TResponse>({
    ...config,
    data,
    method: 'delete',
    url,
  });

export const api = {
  delete: performDelete,
  get: performGet,
  post: performPost,
  put: performPut,
};
